<template>
  <div>
    <v-toolbar color=white flat id="app-bar" class="pa-0 ma-0">
      <div class="image-container">
        <v-img
          class="mx-5 mt-1"
          src="../assets/header/MejoraCareLogo.svg"
          max-height="45"
          max-width="45"

        ></v-img>
      </div>

      <!--<div class="image-container ma-0 pa-0">
        <v-img
          class="mx-5 mt-1"
          src="../assets/Logo Saludable.png"
          max-height="80"
          max-width="80"
        ></v-img>
      </div>-->

      <v-toolbar-items class="pl-5">
        <v-btn text router to="/all-users" v-if="userIsAuthenticated">
          <span>
            USUARIOS
          </span>
        </v-btn>
        <v-btn  text class="ml-5" router to="/my-users" v-if="userIsAuthenticated">
          <span>
            MIS USUARIOS ASIGNADOS
          </span>
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <div 
        @click="openSearch"
        id="search-container"
        :class="searchOpen ? 'light' : 'white'"
        v-if="$route.name === 'AllUsers'"
      >
        <svgicon  class="mx-5 mt-2" icon="search"
          width="2rem" height="2rem" 
          :color="searchOpen ? 'white' : '#32b6ec'">
        </svgicon>
      </div>

      <div id="user-details" class="pl-5">
        <v-layout align-center>
          <svgicon icon="profile" width="2.2rem" height="2.2rem" color="#aab2bd"></svgicon>
          <div class="ml-2">
            <span id="username"> {{userDisplayName}} </span> <br>
            <span id="userrole"> ADMINISTRADOR </span>
          </div>
        </v-layout>
      </div>


      <v-btn icon text-align-left class="mr-5" v-if="userIsAuthenticated"
      @click="onLogOut">
        <v-icon left>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-toolbar>
    <search-bar :display="searchOpen"/>
  </div>
</template>

<script>
  import SearchBar from './SearchBar'

  export default {
    name: 'AppBar',

    components: {
      SearchBar,
    },

    data() {
      return {
        searchOpen: false,
      }
    },

    watch: {
      '$route' () {
        this.searchOpen = false;
      }
    },

    computed: {
      userIsAuthenticated() {
        return this.$store.getters['admins/user'] != null && this.$store.getters['admins/user'] != undefined;
      },
      userDisplayName () {
        return this.$store.getters['admins/userDisplayName']
      }
    },

    methods: {
        onLogOut() {
            this.$store.dispatch('admins/logout')
        },
        openSearch() {
          this.searchOpen = !this.searchOpen
        },
    },
  }
</script>

<style scoped lang="scss">
  #app-bar {
    box-shadow: 0 2px 0 0 #bae8fe;
    max-height: 64px;

    span {
      color: #555f6b;
    }

    a.v-btn--active {
      color: white;
      border-bottom: 5px solid #79d0f9;
      span {
        color: #222c38;
        font-weight: 600;
      }
    }
  }
  .image-container {
    height: 100%;
    box-shadow: 2px 0 0 0 #d7f4ff;
  }

  #search-container {
    box-shadow: -2px 0 0 0  #d7f4ff;
    height: 120%;
    padding-top: 5px;
    margin-right: 2px;

    &:hover {
      cursor: pointer;
    }
  }

  #user-details {
    box-shadow: -2px 0 0 0  #d7f4ff;
    padding-left: 0.5rem;

    #username {
      color: #222c38 !important;
      font-size: 1.125rem;
    }

    #userrole {
      color: #8c95a1;
    }
  }

  
</style>